// removed by extract-text-webpack-plugin
module.exports = {"icon":"Icon__icon___YFXFc","spin":"Icon__spin___10Ci3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.css
// module id = 345
// module chunks = 0